// @flow

// Libs
import { createSelector } from 'reselect'

// Utils
import traverse from 'fc-utils/traverse'

// Selectors
import tableOperation$ from './tableOperation'

// Constants
import { PROP_SUBFIELD } from 'fc-model-sampling-jobs'

export default createSelector(
  [tableOperation$],
  function (tableOperation: Object): number {
    return traverse(['model', PROP_SUBFIELD], { default: {} })(tableOperation)
  }
)
